import React, { useContext, useState } from 'react';
import { useLazyQuery, useMutation } from '@apollo/client';
//import { parseRawData } from '../../parsers';
import _ from 'lodash';
import { getSummaryData, getSummaryDataV2 } from 'gqlQueries/promoRecommendation';
import { summaryDataParser, summaryDataParserV2 } from 'parser/promoRecommendation';
import { UserContext } from 'contexts/ConfigContext';
import { getConfig } from 'utils/helperMethods';

const errorMessage: string = 'Something went wrong!';

function useFetchSummaryData() {
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<null | string>(null);
    const [data, setData] = useState<any>(null);
    const { appConfig } = useContext(UserContext);
    const promoRecommendationConfig = getConfig('promoRecommendation', appConfig);
    const isSummaryV2Enabled = promoRecommendationConfig?.summaryTableV2 || false;

    const [fetchSummaryData, { data: eventsListData, loading: eventsListDataLoading, error: eventsListDataError }] =
        useLazyQuery(isSummaryV2Enabled ? getSummaryDataV2 : getSummaryData, {
            onCompleted: onFetchComplete,
            onError: onFetchError,
        });

    //called when fetching is complete
    function onFetchComplete(payload: any) {
        try {
            if (isSummaryV2Enabled) {
                const { getPlansSummaryV2 } = payload;
                if (getPlansSummaryV2 && Array.isArray(getPlansSummaryV2)) {
                    const parsedData = summaryDataParserV2(getPlansSummaryV2, appConfig);
                    setData(parsedData);
                }
            } else {
                const { getPlansSummary } = payload;
                if (getPlansSummary && Array.isArray(getPlansSummary)) {
                    const parsedData = summaryDataParser(getPlansSummary);
                    setData(parsedData);
                }
            }
            //if data present parse it
        } catch (error) {
            console.error(errorMessage, error);
            onFetchError(error);
        } finally {
            setLoading(false);
        }
    }

    //called when API throws an error
    function onFetchError(error: any = errorMessage) {
        setLoading(false);
        setData(null);
        setError(String(error));
    }

    return {
        loading,
        error,
        data,
        fetchSummaryData: (variables: any) => {
            setError(null);
            setLoading(true);
            setData(null);
            fetchSummaryData(variables);
        },
    };
}

export { useFetchSummaryData };
